import Language from "../Shared/Language/Language";

export { MetadataControllerSingleton as default };

/**
* Changes metatags and titles from a page
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MetadataController {

  /**
   * Variable that represents the Favicon link on the page
   *
   * @private
   *
   * @param {Object}
   *
   * @since 7.0.0
   */
  favicon = document.head.querySelector("#favicon");

  /**
   * Variable that represents the Title page
   *
   * @private
   *
   * @param {Object}
   *
   * @since 7.0.0
   */
  title = document.head.querySelector("#title_page");

  /**
   * Title of the fixed page that is present in all
   * Navigation pages
   *
   * @param {string}
   *
   * @public
   *
   * @since 7.0.0
   */
  DEFAULT_PAGE_TITLE = 'SAPO MAIL'

   /**
   * Adds a title to the page that is visible
   *
   * @public
   *
   * @param {String} title
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  setPageTitle(title){
    this.title.textContent = `${Language.say(title)} - ${this.DEFAULT_PAGE_TITLE}`;
  }

  /**
  * Toggles the favicon of the page based on the given notification state.
  *
  * @publicS
  *
  * @param {Boolean} has_notification - Indicates whether there is an active notification or not.
  *
  * @since 7.0.0
  *
  * @return {void}
  */
  toggleFavicon(has_notification = false){
    const state = has_notification ? this.favicon.getAttribute('data-active') : this.favicon.getAttribute('data-not-active');
    this.favicon.setAttribute('href', state);
  }
}

const MetadataControllerSingleton = new MetadataController();